export enum PanelType {
    Notifications = "Notifications",
    Settings = "Settings",
    Help = "Help",
    UserSettings = "My account",
    AppLauncher = "App launcher"
}